import { render, staticRenderFns } from "./AddBuildings.vue?vue&type=template&id=9178de78&scoped=true"
import script from "./AddBuildings.vue?vue&type=script&lang=js"
export * from "./AddBuildings.vue?vue&type=script&lang=js"
import style0 from "./AddBuildings.vue?vue&type=style&index=0&id=9178de78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9178de78",
  null
  
)

export default component.exports